import { FunctionComponent, h } from 'preact';
import './button.scss';

interface ButtonProps extends preact.JSX.HTMLAttributes<HTMLButtonElement> {
  color?: 'white' | 'blue';
  type?: 'button' | 'submit' | 'reset';
  children?: preact.ComponentChildren;
}

export const Button: FunctionComponent<ButtonProps> = ({
  children,
  color = 'blue',
  className = '',
  type = 'button',
  ...rest
}) => (
  <button type={type} className={`uw-button uw-button_${color} ${className}`} {...rest}>
    {children}
  </button>
);
